import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import FallbackImage from "components/atoms/FallbackImage";

const TYPES = ["standard", "cover"];

const Image = (props) => {
  const {
    className,
    type = "standard",
    src,
    alt,
    fallbackImg,
    role,
    ...rest
  } = props;

  const componentClass = classnames(
    "sal-image",
    { [`sal-image-${type}`]: type != "standard" },
    className,
  );

  return src || fallbackImg ? (
    <img
      className={componentClass}
      src={src ? src : fallbackImg}
      alt={alt}
      role={role}
      {...rest}
    />
  ) : (
    <FallbackImage
      type={type}
      className={componentClass}
      alt={alt}
      role={role}
    />
  );
};

Image.propTypes = {
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  fallbackImg: PropTypes.string,
  src: PropTypes.string,
  type: PropTypes.oneOf(TYPES),
  role: PropTypes.string,
};

export default Image;
